'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'
import { useIsHydrated } from '@/hooks/use-is-hydrated'
import { readClickContextFromLocation } from '@/lib/click-context-decode'
import { comparisonHrefWithContext } from '@/lib/comparison-click-context'

/** Keep comparison arrivals attributable through the existing product page.
 * Initial markup stays canonical; context is carried only after hydration. */
export function ComparisonContextLink({ href, fin, ...props }: Omit<ComponentProps<typeof Link>, 'href'> & { href: string; fin?: string | null }) {
  const hydrated = useIsHydrated()
  const destination = comparisonHrefWithContext(href, hydrated ? readClickContextFromLocation() : null, fin)
  return <Link {...props} href={destination} />
}
